import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=3013487e&scoped=true"
import script from "./step4.vue?vue&type=script&lang=js"
export * from "./step4.vue?vue&type=script&lang=js"
import style0 from "./step4.vue?vue&type=style&index=0&id=3013487e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3013487e",
  null
  
)

export default component.exports